module.exports = __webpack_public_path__ + "static/downtown-c7bc2eb86c58f293e332e13be32cf6f2.mp4";